<template lang="pug">
  main
    NavBar
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns.section-title
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.title Sección de Vehículos
              | &nbsp
              a.button.is-black.is-rounded(@click="backToPage")
                i.fas.fa-times
        .columns.has-text-centered
          .column.is-3
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-car.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 Unidades
                br
                router-link.a.button.is-dark.is-rounded.is-size-6(to="/Transportes/Vehiculos/Unidades") Entrar
        .columns.column-blanco
</template>

<script>
import Loader from '@/components/shared/Loader.vue'
import NavBar from './layout/NavBarTransportes.vue'
import { mapState } from 'vuex'

export default {
  name: 'HomeCombustibles',
  components: { Loader, NavBar },
  data () {
    return {
      isLoading: false,
    }
  },
  methods: {
    obtenerUser() {
      if (Object.keys(this.userLogin).length === 0) {
        this.$router.push('/')
      } 
    },
    backToPage () {
      this.$router.back()
    }
  },
  created () {
    this.obtenerUser()
  },
  computed: {
    ...mapState(['logueado', 'userLogin'])
  },
}
</script>

<style lang="css" scoped>
  .column-blanco {
    padding-bottom: 100px;
  }
  .image {
    display: inline-block;
  }
  .card:hover {
    transform: translateY(-5px) scale(1.005) translateZ(0);
    box-shadow: 0 24px 36px rgba(0,0,0,0.11), 0 14px 16px rgba(0,0,0,0.11);
  }

  .section-title {
    margin-top: 1rem;
    margin-bottom: 2rem;
  }
</style>




// WEBPACK FOOTER //
// src/components/combustibles_Componentes/HomeVehiculos.vue